import React from 'react';
import AsyncSelect from 'react-select/async';
import { useTheme } from '../../contexts/ThemeContext';

interface ThemedAsyncSelectProps {
  isMulti?: boolean;
  cacheOptions?: boolean;
  defaultOptions?: boolean | any[];
  loadOptions: (inputValue: string) => Promise<any[]>;
  value: any;
  onChange: (value: any) => void;
  placeholder: string;
  className?: string;
  classNamePrefix?: string;
  classNames?: {
    [key: string]: (state: any) => string;
  };
}

const ThemedAsyncSelect: React.FC<ThemedAsyncSelectProps> = (props) => {
  const { theme } = useTheme();
  
  const customStyles = {
    control: (base: any) => ({
      ...base,
      minHeight: '38px',
      backgroundColor: theme === 'dark' ? '#374151' : 'white',
      borderColor: theme === 'dark' ? '#4B5563' : '#E5E7EB'
    }),
    menu: (base: any) => ({
      ...base,
      backgroundColor: theme === 'dark' ? '#374151' : 'white',
      zIndex: 9999 // Fix dropdown visibility
    }),
    option: (base: any, state: any) => ({
      ...base,
      backgroundColor: theme === 'dark'
        ? state.isFocused ? '#4B5563' : '#374151'
        : state.isFocused ? '#F3F4F6' : 'white',
      color: theme === 'dark' ? '#F3F4F6' : '#111827'
    }),
    input: (base: any) => ({
      ...base,
      color: theme === 'dark' ? '#F3F4F6' : '#111827' // Fix dark mode input text
    }),
    multiValue: (base: any) => ({
      ...base,
      backgroundColor: theme === 'dark' ? '#4B5563' : '#E5E7EB'
    }),
    multiValueLabel: (base: any) => ({
      ...base,
      color: theme === 'dark' ? '#F3F4F6' : '#111827'
    })
  };

  return (
    <AsyncSelect
      {...props}
      styles={customStyles}
    />
  );
};

export default ThemedAsyncSelect;
